import { reducer as app, initialState as appInitialState } from "./app";

import {
  reducer as specialties,
  initialState as specialtiesInitialState,
} from "./specialties";

import {
  reducer as drugInteractions,
  initialState as drugInteractionsInitialState,
} from "./drug-interactions";

import {
  reducer as viewmodel,
  initialState as viewmodelInitialState,
} from "./viewmodel";

import { reducer as browse } from "./browse/reducer";

//the name of the reducer in "reducers" object below has to be the same
//as the name of initial state of this reducer in "initialState" object below
export const initialState = {
  app: appInitialState,
  specialties: specialtiesInitialState,
  drugInteractions: drugInteractionsInitialState,
  viewmodel: viewmodelInitialState,
  browse: {},
};

const reducers = {
  app,
  specialties,
  drugInteractions,
  browse,
  viewmodel,
};

export const combineReducers = (reducersObj) => {
  return (state, action) => {
    return Object.keys(reducersObj).reduce((nextState, key) => {
      nextState[key] = reducersObj[key](state[key], action);
      return nextState;
    }, {});
  };
};

export const reducer = combineReducers(reducers);
